import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbIconModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbUserModule,
  NbTabsetModule,
  NbTooltipModule,
  NbToggleModule,
  NbAccordionModule,
  NbProgressBarModule,
  NbSpinnerModule,
} from "@nebular/theme";
import { CountrySelectorComponent } from "./country-selector/country-selector.component";
import { CountySelectorComponent } from "./county-selector/county-selector.component";
import { AddressSelectorComponent } from "./address-selector/address-selector.component";
import { CompanySelectorComponent } from "./company-selector/company-selector.component";
import { WipKitCardComponent } from "./wip-kit-card/wip-kit-card.component";
import { TapeInformationComponent } from "./tape-information/tape-information.component";
import { KitSelectorComponent } from "./kit-selector/kit-selector.component";
import { FormFieldErrorComponent } from "./form-field-error/form-field-error.component";
import { TapeScanDetailsComponent } from "./tape-scan-details/tape-scan-details.component";
import { ScannerSelectorComponent } from "./scanner-selector/scanner-selector.component";
import { ProcessSelectorComponent } from "./process-selector/process-selector.component";
import { KitDetailsComponent } from "./kit-details/kit-details.component";
import { ModelSelectorComponent } from "./model-selector/model-selector.component";
import { ManufacturerSelectorComponent } from "./manufacturer-selector/manufacturer-selector.component";
import { AutoFocusDirective } from "./directives/auto-focus.directive";
import { NumbersOverviewComponent } from "./numbers-overview/numbers-overview.component";
import { TapeChartComponent } from "./tape-chart/tape-chart.component";
import { JobWipComponent } from "./job-wip/job-wip.component";
import { JobCreatedChartComponent } from "./job-created-chart/job-created-chart.component";
import { NgxEchartsModule } from "ngx-echarts";
import { AgGridModule } from "ag-grid-angular";

import { ProgressBarComponent } from "./job-wip/progress-bar.component";
import { TapeRaceComponent } from "./tape-race/tape-race.component";
import { JobTypeSelectorComponent } from "./job-type-selector/job-type-selector.component";
import { TapeAnalysisViewerComponent } from "./tape-analysis-viewer/tape-analysis-viewer.component";
import { ManifestItemsDisplayComponent } from "./manifest-items-display/manifest-items-display.component";
import { ManifestSummaryComponent } from "./manifest-summary/manifest-summary.component";
import { BookInAssetTagComponent } from "./book-in-asset-tag/book-in-asset-tag.component";
import { DispatchHardware } from "./dispatch-hardware/dispatch-hardware.component";
import { SalesOrderSelectorComponent } from "./sales/sales-order-selector.component";
import { SalesOrderBatchSelectorComponent } from "./sales/sales-order-batch-selector.component";
import { TapeListComponent } from "./tape-list/tape-list.component";
import { SalesOrderBatchTableComponent } from "./sales/sales-order-batch-table/sales-order-batch-table.component";
import { SalesOrderTableComponent } from "./sales/sales-order-table/sales-order-table.component";
import { TapeTableComponent } from "./sales/tape-table/tape-table.component";

@NgModule({
  imports: [
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbDatepickerModule,
    NbIconModule,
    NbInputModule,
    NbRadioModule,
    NbSelectModule,
    NbUserModule,
    NbProgressBarModule,
    CommonModule,
    NgSelectModule,
    FormsModule,
    NbTabsetModule,
    NbTooltipModule,
    NbToggleModule,
    NbAccordionModule,
    NbSpinnerModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    AgGridModule,
    ReactiveFormsModule,
  ],
  declarations: [
    AddressSelectorComponent,
    CompanySelectorComponent,
    WipKitCardComponent,
    TapeInformationComponent,
    CountySelectorComponent,
    CountrySelectorComponent,
    KitSelectorComponent,
    FormFieldErrorComponent,
    TapeScanDetailsComponent,
    ScannerSelectorComponent,
    ProcessSelectorComponent,
    KitDetailsComponent,
    ModelSelectorComponent,
    AutoFocusDirective,
    ManufacturerSelectorComponent,
    NumbersOverviewComponent,
    TapeChartComponent,
    JobWipComponent,
    JobCreatedChartComponent,
    ProgressBarComponent,
    TapeRaceComponent,
    JobTypeSelectorComponent,
    TapeAnalysisViewerComponent,
    ManifestItemsDisplayComponent,
    ManifestSummaryComponent,
    BookInAssetTagComponent,
    DispatchHardware,
    SalesOrderSelectorComponent,
    SalesOrderBatchSelectorComponent,
    TapeListComponent,
    SalesOrderBatchTableComponent,
    SalesOrderTableComponent,
    TapeTableComponent
  ],
  exports: [
    NgSelectModule,
    AddressSelectorComponent,
    CompanySelectorComponent,
    WipKitCardComponent,
    TapeInformationComponent,
    CountySelectorComponent,
    CountrySelectorComponent,
    KitSelectorComponent,
    FormFieldErrorComponent,
    TapeScanDetailsComponent,
    ScannerSelectorComponent,
    ProcessSelectorComponent,
    KitDetailsComponent,
    ModelSelectorComponent,
    AutoFocusDirective,
    ManufacturerSelectorComponent,
    NumbersOverviewComponent,
    TapeChartComponent,
    JobWipComponent,
    JobCreatedChartComponent,
    NgxEchartsModule,
    TapeRaceComponent,
    JobTypeSelectorComponent,
    TapeAnalysisViewerComponent,
    ManifestSummaryComponent,
    BookInAssetTagComponent,
    DispatchHardware,
    SalesOrderSelectorComponent,
    SalesOrderBatchSelectorComponent,
    TapeListComponent,
    SalesOrderBatchTableComponent,
    SalesOrderTableComponent,
    TapeTableComponent
  ],
})
export class InsurgoUIComponents {}
